// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * InvoiceLineAttributes type.
 * @typedef {object} InvoiceLineAttributes
 * @property {string} id - Attribute value.
 * @property {number | null} amountCents - Attribute value.
 * @property {string} amountCurrency - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string} displayTitle - Attribute value.
 * @property {string | null} invoiceId - Attribute value.
 * @property {number | null} quantity - Attribute value.
 * @property {string | null} timelogId - Attribute value.
 * @property {string | null} title - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 */
/**
 * Attributes accepted by InvoiceLineCreateAttributes.
 * @typedef {object} InvoiceLineCreateAttributes
 * @property {InvoiceLineAttributes["amountCents"] | null} [amountCents] - Permitted amountCents value.
 * @property {InvoiceLineAttributes["amountCurrency"] | null} [amountCurrency] - Permitted amountCurrency value.
 * @property {InvoiceLineAttributes["invoiceId"] | null} [invoiceId] - Permitted invoiceId value.
 * @property {InvoiceLineAttributes["quantity"] | null} [quantity] - Permitted quantity value.
 * @property {InvoiceLineAttributes["timelogId"] | null} [timelogId] - Permitted timelogId value.
 * @property {InvoiceLineAttributes["title"] | null} [title] - Permitted title value.
 */
/**
 * Attributes accepted by InvoiceLineUpdateAttributes.
 * @typedef {object} InvoiceLineUpdateAttributes
 * @property {InvoiceLineAttributes["amountCents"] | null} [amountCents] - Permitted amountCents value.
 * @property {InvoiceLineAttributes["amountCurrency"] | null} [amountCurrency] - Permitted amountCurrency value.
 * @property {InvoiceLineAttributes["invoiceId"] | null} [invoiceId] - Permitted invoiceId value.
 * @property {InvoiceLineAttributes["quantity"] | null} [quantity] - Permitted quantity value.
 * @property {InvoiceLineAttributes["timelogId"] | null} [timelogId] - Permitted timelogId value.
 * @property {InvoiceLineAttributes["title"] | null} [title] - Permitted title value.
 */
/**
 * Frontend model for InvoiceLine.
 * @augments {FrontendModelBase<InvoiceLineAttributes, InvoiceLineCreateAttributes, InvoiceLineUpdateAttributes, InvoiceLineAttributes["id"], string>}
 */
class InvoiceLine extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "InvoiceLine",
      attributes: [
        "id",
        "amountCents",
        "amountCurrency",
        "createdAt",
        "displayTitle",
        "invoiceId",
        "quantity",
        "timelogId",
        "title",
        "updatedAt",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      invoice: {type: "belongsTo"},
      timelog: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      invoice: "Invoice",
      timelog: "Timelog",
    }
  }

  /** @returns {InvoiceLineAttributes["id"]} - Attribute value. */
  id() { return /** @type {InvoiceLineAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {InvoiceLineAttributes["id"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {InvoiceLineAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {InvoiceLineAttributes["amountCents"]} - Attribute value. */
  amountCents() { return /** @type {InvoiceLineAttributes["amountCents"]} */ (this.readAttribute("amountCents")) }

  /**
   * @param {InvoiceLineAttributes["amountCents"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["amountCents"] | null} - Assigned value.
   */
  setAmountCents(newValue) { return /** @type {InvoiceLineAttributes["amountCents"] | null} */ (this.setAttribute("amountCents", newValue)) }

  /** @returns {InvoiceLineAttributes["amountCurrency"]} - Attribute value. */
  amountCurrency() { return /** @type {InvoiceLineAttributes["amountCurrency"]} */ (this.readAttribute("amountCurrency")) }

  /**
   * @param {InvoiceLineAttributes["amountCurrency"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["amountCurrency"] | null} - Assigned value.
   */
  setAmountCurrency(newValue) { return /** @type {InvoiceLineAttributes["amountCurrency"] | null} */ (this.setAttribute("amountCurrency", newValue)) }

  /** @returns {InvoiceLineAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {InvoiceLineAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {InvoiceLineAttributes["displayTitle"]} - Attribute value. */
  displayTitle() { return /** @type {InvoiceLineAttributes["displayTitle"]} */ (this.readAttribute("displayTitle")) }

  /**
   * @param {InvoiceLineAttributes["displayTitle"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["displayTitle"] | null} - Assigned value.
   */
  setDisplayTitle(newValue) { return /** @type {InvoiceLineAttributes["displayTitle"] | null} */ (this.setAttribute("displayTitle", newValue)) }

  /** @returns {InvoiceLineAttributes["invoiceId"]} - Attribute value. */
  invoiceId() { return /** @type {InvoiceLineAttributes["invoiceId"]} */ (this.readAttribute("invoiceId")) }

  /**
   * @param {InvoiceLineAttributes["invoiceId"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["invoiceId"] | null} - Assigned value.
   */
  setInvoiceId(newValue) { return /** @type {InvoiceLineAttributes["invoiceId"] | null} */ (this.setAttribute("invoiceId", newValue)) }

  /** @returns {InvoiceLineAttributes["quantity"]} - Attribute value. */
  quantity() { return /** @type {InvoiceLineAttributes["quantity"]} */ (this.readAttribute("quantity")) }

  /**
   * @param {InvoiceLineAttributes["quantity"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["quantity"] | null} - Assigned value.
   */
  setQuantity(newValue) { return /** @type {InvoiceLineAttributes["quantity"] | null} */ (this.setAttribute("quantity", newValue)) }

  /** @returns {InvoiceLineAttributes["timelogId"]} - Attribute value. */
  timelogId() { return /** @type {InvoiceLineAttributes["timelogId"]} */ (this.readAttribute("timelogId")) }

  /**
   * @param {InvoiceLineAttributes["timelogId"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["timelogId"] | null} - Assigned value.
   */
  setTimelogId(newValue) { return /** @type {InvoiceLineAttributes["timelogId"] | null} */ (this.setAttribute("timelogId", newValue)) }

  /** @returns {InvoiceLineAttributes["title"]} - Attribute value. */
  title() { return /** @type {InvoiceLineAttributes["title"]} */ (this.readAttribute("title")) }

  /**
   * @param {InvoiceLineAttributes["title"] | null} newValue - New attribute value.
   * @returns {InvoiceLineAttributes["title"] | null} - Assigned value.
   */
  setTitle(newValue) { return /** @type {InvoiceLineAttributes["title"] | null} */ (this.setAttribute("title", newValue)) }

  /** @returns {InvoiceLineAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {InvoiceLineAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /**
   * Returns invoice relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceLine, import("./invoice.js").Invoice, import("./invoice.js").InvoiceCreateAttributes>} - Relationship helper.
   */
  invoiceRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceLine, import("./invoice.js").Invoice, import("./invoice.js").InvoiceCreateAttributes>} */ (this.getRelationshipByName("invoice")) }

  /**
   * Returns invoice.
   * @returns {import("./invoice.js").Invoice | null} - Loaded related model.
   */
  invoice() { return this.invoiceRelationship().loaded() }

  /**
   * Builds invoice.
   * @param {import("./invoice.js").InvoiceCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./invoice.js").Invoice} - Built related model.
   */
  buildInvoice(attributes = {}) { return this.invoiceRelationship().build(attributes) }

  /**
   * Loads invoice.
   * @returns {Promise<import("./invoice.js").Invoice | null>} - Loaded related model.
   */
  async loadInvoice() { return await this.invoiceRelationship().load() }

  /**
   * Returns or loads invoice.
   * @returns {Promise<import("./invoice.js").Invoice | null>} - Loaded related model.
   */
  async invoiceOrLoad() { return await this.invoiceRelationship().orLoad() }

  /**
   * Sets invoice.
   * @param {import("./invoice.js").Invoice | null} model - Related model.
   * @returns {void}
   */
  setInvoice(model) { this.invoiceRelationship().setLoaded(model) }

  /**
   * Returns timelog relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceLine, import("./timelog.js").Timelog, import("./timelog.js").TimelogCreateAttributes>} - Relationship helper.
   */
  timelogRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<InvoiceLine, import("./timelog.js").Timelog, import("./timelog.js").TimelogCreateAttributes>} */ (this.getRelationshipByName("timelog")) }

  /**
   * Returns timelog.
   * @returns {import("./timelog.js").Timelog | null} - Loaded related model.
   */
  timelog() { return this.timelogRelationship().loaded() }

  /**
   * Builds timelog.
   * @param {import("./timelog.js").TimelogCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./timelog.js").Timelog} - Built related model.
   */
  buildTimelog(attributes = {}) { return this.timelogRelationship().build(attributes) }

  /**
   * Loads timelog.
   * @returns {Promise<import("./timelog.js").Timelog | null>} - Loaded related model.
   */
  async loadTimelog() { return await this.timelogRelationship().load() }

  /**
   * Returns or loads timelog.
   * @returns {Promise<import("./timelog.js").Timelog | null>} - Loaded related model.
   */
  async timelogOrLoad() { return await this.timelogRelationship().orLoad() }

  /**
   * Sets timelog.
   * @param {import("./timelog.js").Timelog | null} model - Related model.
   * @returns {void}
   */
  setTimelog(model) { this.timelogRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(InvoiceLine)

export {InvoiceLine}

export default InvoiceLine
